import { Box } from '@mui/material';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import React from 'react';
import { StepTest } from 'types/SparkStep';
import { parseJSONCleaned } from 'utilities/index';
import { useCurrentRoute } from 'hooks/common';
import { useSparkBuilderStore } from 'stores';

type RenderPropType = {
  isLinked: boolean;
  isError: boolean;
  onError: (errorMessage: string) => void;
};

type BoardNodeStepConnectionWrapperProps = {
  sparkStepID: string | null;
  readOnly?: boolean;
  render: (props: RenderPropType) => React.ReactNode;
  isSparkOutputPreview?: boolean;
};

function BoardNodeStepConnectionWrapper({
  render,
  sparkStepID,
  readOnly = false,
  isSparkOutputPreview = false,
}: BoardNodeStepConnectionWrapperProps) {
  const [error, setError] = React.useState<string | null>(null);
  const { isSparkBuilder } = useCurrentRoute();

  const sparkSteps = useSparkBuilderStore((store) => store.sparkSteps);
  const sparkStep = sparkSteps.data?.find((step) => step.id === sparkStepID);

  if (!sparkStep || !isSparkBuilder) {
    return (
      <Box width='100%'>
        {render({ isLinked: false, onError: setError, isError: false })}
      </Box>
    );
  }

  const hasTestIssues = sparkStep.meta.diagnostics.hasTestIssues;

  const sparkTestResults = parseJSONCleaned<StepTest>(
    sparkStep?.attributes.testResults || ''
  );
  const output = sparkTestResults?.SparkTask.Output;
  const isError = !output || hasTestIssues || !!error;

  return (
    <Box position='relative' width='100%'>
      <Box
        component='span'
        position='absolute'
        top={-12}
        right={-12}
        padding={0.5}
        sx={{ zIndex: 1, transform: 'rotate(-45deg)', aspectRatio: 1 }}
        borderRadius='50%'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
        bgcolor='white'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <InsertLinkIcon />
      </Box>
      <>{render({ isLinked: true, onError: setError, isError })}</>
    </Box>
  );
}

export default BoardNodeStepConnectionWrapper;
